import * as $$ from "jquery-selector-cache";

/**
 * Initialize the component
 */
export function initMainSearch() {
    // Exit when component don't exist
    if (!$$(".cpt-main-nav").length) {
        return;
    }
    $(".btn-back-return").on("click", handleBack);
    $(".btn-search").on("click", handleSearch);
}

/**
 * handle back
 */
function handleBack(evt: JQuery.TriggeredEvent<HTMLElement>) {
    evt.preventDefault();
    window.history.back();
}

/**
 * handle back
 */
function handleSearch(evt: JQuery.TriggeredEvent<HTMLElement>) {
    evt.preventDefault();
    $$("#loginErrorMsg").addClass("hidden");
    const target = $(evt.currentTarget);
    const url = target.data("url");
    window.location.href = url;
}
